import React from "react";
import { sendSuccessNotification } from "../../../../../universal/notifications/notifications";
import Lottie from "react-lottie-player";
import emptyAnimation from "../../../../../../resources/email-animation.json";
import "./style.scss";

const Index = () => {
  return (
    <div className="get-started-container">
      <div className="animation-container">
        <Lottie
          animationData={emptyAnimation}
          loop
          play
          className="animation-player"
        />
      </div>
      <h3 className="get-started-title">Alt er klart!</h3>
      <p className="get-started-description">
        All nødvendig verifisering og data har blitt konfigurert, og du kan nå
        starte å sende e-post. Hva venter du på - la oss komme i gang!
      </p>
    </div>
  );
};

export default Index;
